import React, { Component } from "react";

import Header from "./../common/header-mini";

import { scrollToTop } from "./../../helpers/screen";

export default class Mini extends Component {
    componentDidMount() {
        scrollToTop();
    }

    render() {
        const { id, dark = true, children = "", type = false, extensions = false } = this.props;

        return (
            <div id={id} className={`layout-mini ${type}`}>
                <div id="page-top"></div>
                <div className="content-container">
                    <Header darkmode={dark} type={type} extensions={extensions} />
                    {children}
                </div>
            </div>
        );
    }
}
